import { getSiteInfo } from '../SiteConfigs.js';

let SITE_INFO = getSiteInfo();

function init_unit(mixi_id, target, fark_target, widget, insertHere)
{
    
    // console.log("fark widget init_unit", mixi_id, target, fark_target, widget, insertHere);

    // console.log("FARK WIDGET INSERT DETAILS", "TARGET", fark_target, "WIDGET", widget);
    if( insertHere == 'append' ){
        $(fark_target).append( widget );
    } else if( insertHere == 'after' ) {
        $(fark_target).after( widget );
    } else if( insertHere == 'before' ) {
        $(fark_target).before( widget );
    } else {
        $(fark_target).after( widget );
    }

    var sc = document.createElement('script');
    sc.type = 'text/javascript';
    sc.async = true;
    sc.src = '//mixi.media/data/js/'+mixi_id+'.js';
    sc.charset = 'utf-8';
    var s = document.getElementsByTagName('script')[0];
    s.parentNode.insertBefore(sc, s);
}

function lazy_load_unit(mixi_id, target, fark_target, widget, insertHere)
{
    var lazy_init_callback = function(){
        if( window.$(fark_target).length > 0 && window.$(fark_target).inViewport(30) ){
            init_unit(mixi_id, target, fark_target, widget, insertHere);
            $(window).off("scroll rezise", lazy_init_callback);
        }
    }

    $(window).on('scroll rezise', lazy_init_callback).scroll().resize();
}

/*
 * FARK Widget : RCP, RCW, RCD, RCSci, RCHist, RCM
 * Homepage Locations : LC or RC
 * Article Locations  : MC && RC
*/
function fark_widget(location, override_mixi_id)
{   
    if( typeof override_mixi_id === 'undefined' ){
        override_mixi_id = null;
    }

    if(override_mixi_id !== null){console.log('orale mixi override: '+override_mixi_id);}

    if($('div.beta').is("[data-sponsored-ads-only]")) {
        // If marked as "Sponsored Ads Only", do not show this ad
        return;
    }

    var mixi_id, target, fark_target, widget, insertHere;

    if( location == 'left' ){ //Homepage Left Column
        mixi_id = 92311;
        if(override_mixi_id!==null){ mixi_id=override_mixi_id; }
        target = 'div.gamma';
        if( SITE_INFO['name'] != 'science' ){ //RCD, RCW
            fark_target = 'div.gamma .widget_slot:eq(1)';
            insertHere = 'after';
        }else{ //RCSci
            fark_target = 'div.gamma';
            insertHere = 'append';
        }

        widget = '<style type="text/css">#header_'+mixi_id+'{background-color:'+SITE_INFO['site_heading_color']+' !important;}</style><div class="mixi_unit" id="unit_'+mixi_id+'"><a href="https://mixi.media/" rel="nofollow"></a></div>';

    }else if( location == 'simple_left' ){ //new widget - without images - bottom left column
        mixi_id = 92584;
        target = 'ul#most-read-box';
        fark_target = 'ul#most-read-box';
        insertHere = 'after';

        widget = '<div class="fark-header" style="font-size:13px; background-color:'+SITE_INFO['site_heading_color']+'; color: #FFFFFF; padding: 15px 15px; width: auto; font-weight: bold; margin-bottom: 0px;">News From Partners</div>';
        widget += '<div style="min-height: 933px;" class="mixi_unit" id="unit_'+mixi_id+'"><a href="https://mixi.media/" rel="nofollow"></a></div>';
        widget += '<style>#container_92584 #header_92584{display:none;}</style>';  // Hides the 'Recent News' Title Header.

    }else if( location == 'middle' ){ //Article Permalinks(Standard) Middle Column
        mixi_id = 92313;
        target = 'div.alpha';
        fark_target = 'div.alpha';
        insertHere = 'append';

        widget = '<style type="text/css">#container_92313 {margin-top:10px; border-bottom:1px solid #DDDDDD;} #container_92313 .list-container {border-left:1px solid #DDDDDD; border-right:1px solid #DDDDDD; padding-top:10px;} #unit_92313 h2 {background-color: '+SITE_INFO['site_heading_color']+'; padding: 10px; color: white; font-size: 1.3em; margin:0; }</style><div class="mixi_unit" id="unit_'+mixi_id+'"><a href="https://mixi.media/" rel="nofollow"></a></div>';

    }else{ //loc == right/default
        mixi_id = 91801;
        target = 'div.beta';
        var w_header = '<div class="fark-header" style="font-size:13px; background-color:'+SITE_INFO['site_heading_color']+'; color: #FFFFFF; padding: 15px 15px; width: auto; font-weight: bold; margin-bottom: 0px;">News From Partners</div>';
        widget = '';

        if( SITE_INFO['name'] != "politics" ){ //All Sites EXCEPT RCP Right Column(article pages only)
            fark_target = 'div.beta';
            insertHere = 'append';
        }else if( $('body').hasClass('article') ) {
            mixi_id = 94208;
            w_header = ''; // Clears header
            widget += '<br />';
            fark_target = '';

            if(SITE_INFO['name'] != 'politics'){
                fark_target = 'div.beta .RC-AD:eq(1)';
                insertHere = 'before';
            } else {
                fark_target = 'div.beta';
                insertHere = 'append';
            }

            //Inserting the widget on mobile on the beta column
            if(document.body.clientWidth < 768){

                //we are removing the mixi widget on mobile on politics
                if(SITE_INFO['name'] != 'politics') {
                    fark_target = 'div.alpha #comments-container';
                    insertHere = 'after';
                }
            }

        }else{


            if( $('body').hasClass('home') && document.body.clientWidth<768 ){ //HOMEPAGE MOBILE only

                mixi_id = 94488; //custom 1x3
                fark_target = 'div#hpstreams';
                insertHere = 'before';

                w_header = "<div class='clear' style='margin-top:10px;'></div>"+w_header; //MORE PADDING

            }else{
                //Default behaivior will be targeting the right column
                //Mobile : right column is hidden
                // fark_target = 'div.beta .widget_slot:eq(3)';
                fark_target = 'div.beta #fark-right-col-desktop';
                insertHere = 'after';
            }


        }

        widget = '<div style="min-height: 1195px;" class="mixi_unit" id="unit_'+mixi_id+'"><a href="https://mixi.media/" rel="nofollow"></a></div>' + widget;

        widget = w_header + widget;
    }

    // if ads are already lazyloaded with ads, change target
    if( $(fark_target).length == 0 ) {
        fark_target = fark_target.replace('.RC-AD', '.lazyloaded');
    }

    lazy_load_unit(mixi_id, target, fark_target, widget, insertHere);

}

function display_fark_widget()
{
    if (SITE_INFO['name'] == 'politics') {

        if ($('body').hasClass('home') && document.body.clientWidth >= 768) {

            fark_widget('right');

        } else if ($('body').hasClass('article') || $('body').hasClass('video') || $('body').hasClass('polls') || $('body').hasClass('polls')) {

            fark_widget('right');
            fark_widget('simple_left');
        }
    } else if ((SITE_INFO['name'] == 'markets' || SITE_INFO['name'] == 'history') && $('body').hasClass('home')) {
        fark_widget('right');
        if (SITE_INFO['name'] == 'markets') {
            fark_widget('left', '94201');
        }
    } else if ((SITE_INFO['name'] == 'defense' || SITE_INFO['name'] == 'world' || SITE_INFO['name'] == 'science') && $('body').hasClass('home')) {
        fark_widget('left');
    } else if ((SITE_INFO['name'] == 'defense' || SITE_INFO['name'] == 'world' || SITE_INFO['name'] == 'science' || SITE_INFO['name'] == 'markets' || SITE_INFO['name'] == 'history') && $('body').hasClass('article')) {
        $(".newsletter-signup-container2").last().hide();
        $(".newsletter-widget").css({"margin-bottom": "20px"});

        fark_widget('middle');
        fark_widget('right');
    }
}

export default display_fark_widget;